export default __webpack_public_path__ + "static/connect-1b17902299ba609f4ff66451601894d2.jpg";